export const FacebookIcon = ({ size = 18, color = '#4676ED' }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 9.49977C18 7.684 17.5069 5.90627 16.5793 4.37713C15.6517 2.84798 14.3283 1.63148 12.766 0.871687C11.2036 0.111894 9.46768 -0.159359 7.76378 0.0900519C6.05988 0.339463 4.45938 1.09909 3.15184 2.27897C1.8443 3.45885 0.88448 5.00956 0.386061 6.74744C-0.112357 8.48533 -0.128498 10.3376 0.33955 12.0848C0.807599 13.8321 1.74023 15.4012 3.02699 16.6063C4.31375 17.8113 5.90073 18.6019 7.6 18.8844V12.2442H5.308V9.49977H7.6V7.40696C7.6 5.02562 8.93333 3.7111 10.9933 3.7111C11.6683 3.72107 12.3416 3.78316 13.008 3.89688V6.23459H11.8733C10.7547 6.23459 10.4067 6.96644 10.4067 7.71799V9.49977H12.9027L12.5027 12.2442H10.4067V18.883C12.5233 18.5291 14.451 17.3897 15.8429 15.6697C17.2348 13.9497 17.9997 11.7619 18 9.49977Z"
      fill={color}
    />
    <path
      d="M12.5026 12.244L12.9026 9.4982H10.4067V7.71783C10.4067 6.96627 10.7547 6.23442 11.8733 6.23442H13.008V3.89672C12.3416 3.783 11.6683 3.72091 10.9933 3.71094C8.93332 3.71094 7.59998 5.02546 7.59998 7.40679V9.4996H5.30798V12.244H7.59998V18.8828C8.5321 19.0367 9.4812 19.0367 10.4133 18.8828V12.244H12.5026Z"
      fill="white"
    />
  </svg>
);

export const SuccessIcon = () => (
  <svg
    width={98}
    height={98}
    viewBox="0 0 98 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48.9946 98.0009C21.9793 98.0009 0 76.0284 0 49.0063C0 21.9842 21.9793 0.0117188 48.9946 0.0117188C76.0099 0.0117188 97.9892 21.9911 97.9892 49.0063C97.9892 76.0216 76.0167 98.0009 48.9946 98.0009ZM48.9946 4.68599C24.5655 4.69009 4.67837 24.5773 4.67837 49.0063C4.67837 73.4354 24.5655 93.3266 48.9946 93.3266C73.4237 93.3266 93.3149 73.4449 93.3149 49.0063C93.3149 24.5677 73.4332 4.69009 48.9946 4.69009V4.68599Z"
      fill="#00CC60"
    />
    <path
      d="M38.9391 72.577L18.6111 52.249L25.9248 44.9353L38.9391 57.9495L71.8119 25.0781L79.1256 32.3905L38.9391 72.577Z"
      fill="#00CC60"
    />
  </svg>
);

export const OopsIcon = () => (
  <svg
    width="145"
    height="40"
    viewBox="0 0 145 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2295_1390)">
      <path
        d="M21.2569 29.64C18.2435 29.64 15.5369 29.0133 13.1369 27.76C10.7369 26.5067 8.85688 24.7733 7.49688 22.56C6.13688 20.32 5.45688 17.8 5.45688 15C5.45688 12.2 6.13688 9.69333 7.49688 7.48C8.85688 5.24 10.7369 3.49333 13.1369 2.24C15.5369 0.986666 18.2435 0.359999 21.2569 0.359999C24.2702 0.359999 26.9769 0.986666 29.3769 2.24C31.7769 3.49333 33.6569 5.24 35.0169 7.48C36.3769 9.69333 37.0569 12.2 37.0569 15C37.0569 17.8 36.3769 20.32 35.0169 22.56C33.6569 24.7733 31.7769 26.5067 29.3769 27.76C26.9769 29.0133 24.2702 29.64 21.2569 29.64ZM21.2569 22C22.4302 22 23.4835 21.72 24.4169 21.16C25.3769 20.5733 26.1369 19.76 26.6969 18.72C27.2569 17.6533 27.5369 16.4133 27.5369 15C27.5369 13.5867 27.2569 12.36 26.6969 11.32C26.1369 10.2533 25.3769 9.44 24.4169 8.88C23.4835 8.29333 22.4302 8 21.2569 8C20.0835 8 19.0169 8.29333 18.0569 8.88C17.1235 9.44 16.3769 10.2533 15.8169 11.32C15.2569 12.36 14.9769 13.5867 14.9769 15C14.9769 16.4133 15.2569 17.6533 15.8169 18.72C16.3769 19.76 17.1235 20.5733 18.0569 21.16C19.0169 21.72 20.0835 22 21.2569 22ZM55.1631 29.64C52.1498 29.64 49.4431 29.0133 47.0431 27.76C44.6431 26.5067 42.7631 24.7733 41.4031 22.56C40.0431 20.32 39.3631 17.8 39.3631 15C39.3631 12.2 40.0431 9.69333 41.4031 7.48C42.7631 5.24 44.6431 3.49333 47.0431 2.24C49.4431 0.986666 52.1498 0.359999 55.1631 0.359999C58.1765 0.359999 60.8831 0.986666 63.2831 2.24C65.6831 3.49333 67.5631 5.24 68.9231 7.48C70.2831 9.69333 70.9631 12.2 70.9631 15C70.9631 17.8 70.2831 20.32 68.9231 22.56C67.5631 24.7733 65.6831 26.5067 63.2831 27.76C60.8831 29.0133 58.1765 29.64 55.1631 29.64ZM55.1631 22C56.3365 22 57.3898 21.72 58.3231 21.16C59.2831 20.5733 60.0431 19.76 60.6031 18.72C61.1631 17.6533 61.4431 16.4133 61.4431 15C61.4431 13.5867 61.1631 12.36 60.6031 11.32C60.0431 10.2533 59.2831 9.44 58.3231 8.88C57.3898 8.29333 56.3365 8 55.1631 8C53.9898 8 52.9231 8.29333 51.9631 8.88C51.0298 9.44 50.2831 10.2533 49.7231 11.32C49.1631 12.36 48.8831 13.5867 48.8831 15C48.8831 16.4133 49.1631 17.6533 49.7231 18.72C50.2831 19.76 51.0298 20.5733 51.9631 21.16C52.9231 21.72 53.9898 22 55.1631 22ZM87.8694 0.999998C90.456 0.999998 92.7094 1.42666 94.6294 2.28C96.5494 3.13333 98.0294 4.36 99.0694 5.96C100.109 7.56 100.629 9.42667 100.629 11.56C100.629 13.6933 100.109 15.56 99.0694 17.16C98.0294 18.76 96.5494 19.9867 94.6294 20.84C92.7094 21.6933 90.456 22.12 87.8694 22.12H83.8294V29H74.3894V0.999998H87.8694ZM87.2694 14.84C88.5494 14.84 89.5094 14.56 90.1494 14C90.7894 13.4133 91.1094 12.6 91.1094 11.56C91.1094 10.52 90.7894 9.72 90.1494 9.16C89.5094 8.57333 88.5494 8.28 87.2694 8.28H83.8294V14.84H87.2694ZM114.556 29.64C112.236 29.64 109.969 29.3867 107.756 28.88C105.569 28.3467 103.769 27.64 102.356 26.76L105.396 19.88C106.729 20.6533 108.223 21.28 109.876 21.76C111.529 22.2133 113.116 22.44 114.636 22.44C115.943 22.44 116.876 22.32 117.436 22.08C117.996 21.8133 118.276 21.4267 118.276 20.92C118.276 20.3333 117.903 19.8933 117.156 19.6C116.436 19.3067 115.236 18.9867 113.556 18.64C111.396 18.1867 109.596 17.7067 108.156 17.2C106.716 16.6667 105.463 15.8133 104.396 14.64C103.329 13.44 102.796 11.8267 102.796 9.8C102.796 8.04 103.289 6.44 104.276 5C105.263 3.56 106.729 2.42666 108.676 1.6C110.649 0.773332 113.036 0.359999 115.836 0.359999C117.756 0.359999 119.636 0.573332 121.476 0.999998C123.343 1.4 124.983 2 126.396 2.8L123.556 9.64C120.809 8.25333 118.209 7.56 115.756 7.56C113.329 7.56 112.116 8.14667 112.116 9.32C112.116 9.88 112.476 10.3067 113.196 10.6C113.916 10.8667 115.103 11.16 116.756 11.48C118.889 11.88 120.689 12.3467 122.156 12.88C123.623 13.3867 124.889 14.2267 125.956 15.4C127.049 16.5733 127.596 18.1733 127.596 20.2C127.596 21.96 127.103 23.56 126.116 25C125.129 26.4133 123.649 27.5467 121.676 28.4C119.729 29.2267 117.356 29.64 114.556 29.64ZM129.005 0.999998H139.805L138.005 18.28H130.805L129.005 0.999998ZM134.405 29.4C132.858 29.4 131.592 28.9333 130.605 28C129.618 27.0667 129.125 25.9333 129.125 24.6C129.125 23.24 129.618 22.12 130.605 21.24C131.592 20.3333 132.858 19.88 134.405 19.88C135.952 19.88 137.218 20.3333 138.205 21.24C139.192 22.12 139.685 23.24 139.685 24.6C139.685 25.9333 139.192 27.0667 138.205 28C137.218 28.9333 135.952 29.4 134.405 29.4Z"
        fill="#8F6599"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2295_1390"
        x="0.456879"
        y="0.359375"
        width="144.348"
        height="39.2812"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2295_1390"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2295_1390"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const UserIcon = () => (
  <svg
    width="31"
    height="32"
    viewBox="0 0 31 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4251 0C20.2936 0.0150162 23.6225 2.95902 24.2006 7.2962C24.7657 11.5308 23.4739 15.133 20.443 18.0386C19.417 19.0405 18.1093 19.6794 16.7088 19.8631C14.8882 20.1042 13.3105 19.4585 11.9267 18.2972C9.65145 16.3885 8.4105 13.8558 7.92203 10.9076C7.58616 8.8779 7.71938 6.87825 8.55018 4.99038C10.0156 1.65929 12.6105 0.100108 15.4251 0ZM22.2774 8.8729C22.2055 8.34566 22.1603 7.70497 22.0263 7.08514C21.4094 4.21955 19.1875 2.33001 16.3003 2.18819C13.5204 2.05054 11.1088 3.78825 10.2392 6.53287C8.9902 10.4671 11.1403 15.0846 13.8345 16.9141C15.4372 17.9986 17.039 17.976 18.5456 16.7522C20.971 14.7834 22.0981 12.1256 22.2774 8.8729Z"
      fill="currentColor"
    />
    <path
      d="M0.99707 28.7566C1.07781 24.7523 2.66836 21.5564 5.71463 19.1221C6.39526 18.5781 7.09123 18.0542 7.79123 17.537C8.3564 17.1199 9.00231 17.2108 9.35837 17.7306C9.71443 18.2503 9.55456 18.8901 9.02169 19.3298C7.87762 20.2716 6.67542 21.1576 5.63066 22.2104C3.6889 24.1758 3.10919 26.6952 3.219 29.4248C3.24038 29.6178 3.27328 29.8092 3.3175 29.998C3.36939 30.274 3.31673 30.56 3.17039 30.7971C3.02405 31.0341 2.79521 31.2041 2.53111 31.2718C1.99096 31.4103 1.40642 31.0958 1.26997 30.5168C1.13352 29.9379 1.08508 29.3439 0.99707 28.7566Z"
      fill="currentColor"
    />
    <path
      d="M28.9642 28.7164C28.9327 25.3169 27.4624 22.7191 24.882 20.7236C24.2902 20.2656 23.6927 19.8152 23.0953 19.3647C22.5527 18.9559 22.4074 18.2802 22.7586 17.7654C23.1098 17.2507 23.7339 17.1556 24.2926 17.5536C25.6894 18.5471 27.0458 19.5932 28.202 20.8905C29.8975 22.7967 30.7856 25.0666 30.9721 27.6219C31.0275 28.5335 31.0005 29.4484 30.8914 30.3548C30.8107 31.0873 30.2269 31.451 29.5842 31.3009C28.9973 31.1632 28.7001 30.6076 28.8172 29.9094C28.8842 29.5156 28.9165 29.1143 28.9642 28.7164Z"
      fill="currentColor"
    />
  </svg>
);

export const StreamingIcon = () => (
  <svg
    width="38"
    height="34"
    viewBox="0 0 38 34"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.7558 25.0906C30.7558 26.3231 30.7755 27.557 30.7413 28.7881C30.7334 29.0607 30.5938 29.3754 30.4161 29.5887C30.1764 29.8758 29.8024 29.9324 29.4495 29.7718C29.0848 29.6059 28.8544 29.3188 28.8544 28.8961C28.8517 27.7584 28.8517 26.622 28.8517 25.4843C28.8517 25.354 28.8517 25.2236 28.8517 24.984C28.6489 25.1854 28.5107 25.3263 28.3685 25.4633C27.9326 25.8846 27.2992 25.9241 26.9371 25.5555C26.5632 25.1736 26.5921 24.5521 27.0161 24.1241C27.6969 23.4368 28.3803 22.752 29.069 22.0713C29.5167 21.6288 30.0263 21.5946 30.4845 22.0291C31.2311 22.7362 31.954 23.467 32.6664 24.2084C33.0391 24.5955 33.0154 25.2249 32.6651 25.5581C32.299 25.9044 31.6802 25.8886 31.2878 25.5067C31.135 25.3566 31.0126 25.1749 30.8769 25.0077L30.7558 25.0906Z"
      fill="currentColor"
    />
    <path
      d="M37.283 24.7565C36.8788 22.2822 35.6305 20.3848 33.3788 19.2392C32.5716 18.8283 31.6735 18.5953 30.7571 18.2582V17.9329C30.7571 13.8061 30.761 9.68068 30.7557 5.5539C30.7518 2.58325 28.6423 0.413201 25.6809 0.403983C18.881 0.382915 12.0799 0.384232 5.28006 0.403983C2.35681 0.413201 0.192028 2.55691 0.186761 5.4288C0.172277 12.4709 0.181494 19.5131 0.182811 26.5552C0.182811 27.2781 0.317122 27.9773 0.627882 28.6304C1.57859 30.628 3.19296 31.5879 5.38145 31.5892C11.8192 31.5958 18.2569 31.5932 24.6933 31.5866C24.9764 31.5866 25.195 31.663 25.4202 31.8302C26.7422 32.8125 28.2341 33.3405 29.8801 33.3181C33.151 33.2734 35.8372 31.3324 36.9367 28.2367C37.1329 27.6837 37.2211 27.0924 37.3581 26.5196V25.0672C37.3317 24.9632 37.2988 24.8592 37.2817 24.7538L37.283 24.7565ZM22.9696 29.7826C17.1508 29.7826 11.332 29.8037 5.51312 29.7681C4.17133 29.7602 2.98491 29.273 2.395 27.9325C2.20538 27.5019 2.09477 27.0055 2.08029 26.5354C2.06054 25.8718 2.06449 7.45664 2.06712 5.52756C2.06844 4.01327 2.94278 2.85187 4.39386 2.44499C4.71384 2.35545 5.06279 2.33306 5.39857 2.33306C12.1141 2.32648 18.8297 2.32648 25.5453 2.32911C27.5428 2.32911 28.8714 3.65511 28.8741 5.64607C28.878 8.47583 28.8925 18.3174 28.8925 18.3174C28.8938 18.3174 28.6489 18.3424 28.0959 18.5149H28.0919C25.6506 19.1825 23.8466 20.606 22.8524 22.934C21.8596 25.2595 22.1401 27.5335 23.3094 29.7655C23.1764 29.7721 23.0737 29.7826 22.971 29.7826H22.9696ZM29.7616 31.4049C26.92 31.3956 24.1653 29.0096 24.2008 25.8323C24.2351 22.7128 26.7132 20.2162 29.809 20.2333C32.9482 20.2504 35.429 22.7563 35.4026 25.881C35.3763 28.9728 32.8652 31.4141 29.7629 31.4035L29.7616 31.4049Z"
      fill="currentColor"
    />
    <path
      d="M11.5823 20.1947V11.9162C11.5823 11.4131 12.1116 11.0866 12.5606 11.3118L20.8392 15.4504C21.3383 15.6993 21.3383 16.4103 20.8392 16.6605L12.5606 20.7991C12.1116 21.0243 11.5823 20.6964 11.5823 20.1947Z"
      fill="currentColor"
    />
  </svg>
);

export const ShareAsLinkIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.25 0H16.125C15.5037 0 15 0.503679 15 1.125C15 1.74632 15.5037 2.25 16.125 2.25H23.534L11.9545 13.8295L13.5455 15.4205L25.125 3.84099V11.25C25.125 11.8713 25.6287 12.375 26.25 12.375C26.8713 12.375 27.375 11.8713 27.375 11.25L27.375 1.125C27.375 0.503679 26.8713 0 26.25 0ZM1.5 0.375H11.25V2.625H2.25V25.125H24.75V18.375H27V25.875C27 26.7034 26.3284 27.375 25.5 27.375H1.5C0.671574 27.375 0 26.7034 0 25.875V1.875C0 1.04657 0.671573 0.375 1.5 0.375Z"
      fill="black"
    />
  </svg>
);

export const ShareAsCampaignIcon = () => (
  <svg
    width="40"
    height="32"
    viewBox="0 0 40 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.1261 26.5694L9.20019 20.7758L9.20019 7.31444L28.1261 1.5208L28.1261 26.5694Z"
      stroke="black"
      strokeWidth="2.25"
    />
    <mask id="path-2-inside-1_3613_3878" fill="white">
      <path d="M2.1608 21.6082C0.967423 21.6082 -4.22875e-08 20.6407 -9.44517e-08 19.4474L-5.66711e-07 8.64333C-6.18875e-07 7.44995 0.967424 6.48253 2.1608 6.48253L9.72362 6.48253L9.72362 21.6082L2.1608 21.6082Z" />
    </mask>
    <path
      d="M2.1608 21.6082C0.967423 21.6082 -4.22875e-08 20.6407 -9.44517e-08 19.4474L-5.66711e-07 8.64333C-6.18875e-07 7.44995 0.967424 6.48253 2.1608 6.48253L9.72362 6.48253L9.72362 21.6082L2.1608 21.6082Z"
      stroke="black"
      strokeWidth="4.5"
      mask="url(#path-2-inside-1_3613_3878)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.21053 20.9108C2.16639 21.2838 2.21986 21.6771 2.39279 22.0566L6.34685 30.735C6.69788 31.5055 7.46653 31.9999 8.31318 31.9999H11.6411C13.2134 31.9999 14.2593 30.3741 13.6074 28.9432L12.7265 27.0099H10.254L11.5024 29.7499H8.37055L4.49777 21.2499H6.26667V20.896C6.08149 20.9247 5.89173 20.9397 5.69849 20.9397H2.67337C2.5166 20.9397 2.36212 20.9298 2.21053 20.9108Z"
      fill="black"
    />
    <line
      x1="32.2929"
      y1="6.61443"
      x2="36.6145"
      y2="2.29282"
      stroke="black"
      strokeWidth="2"
    />
    <line
      y1="-1"
      x2="6.11168"
      y2="-1"
      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 35.3218 26.3215)"
      stroke="black"
      strokeWidth="2"
    />
    <line x1="33" y1="14" x2="39.0503" y2="14" stroke="black" strokeWidth="2" />
  </svg>
);

export const ShareAsContactIcon = () => (
  <svg
    width="36"
    height="29"
    viewBox="0 0 36 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="32.3466"
      cy="10.7821"
      r="1.74417"
      transform="rotate(90 32.3466 10.7821)"
      fill="black"
      stroke="black"
      strokeWidth="2.8541"
    />
    <circle
      cx="23.4672"
      cy="17.1246"
      r="1.74417"
      transform="rotate(90 23.4672 17.1246)"
      fill="black"
      stroke="black"
      strokeWidth="2.8541"
    />
    <circle
      cx="32.3468"
      cy="23.4671"
      r="3.17123"
      transform="rotate(90 32.3468 23.4671)"
      fill="black"
    />
    <line
      x1="31.2351"
      y1="11.9361"
      x2="23.6242"
      y2="17.01"
      stroke="black"
      strokeWidth="2.25"
    />
    <line
      x1="22.1788"
      y1="16.8162"
      x2="30.5511"
      y2="22.2704"
      stroke="black"
      strokeWidth="2.25"
    />
    <mask id="path-6-inside-1_3613_4141" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1157 11.3895C14.4358 10.1926 15.2649 8.464 15.2649 6.54174C15.2649 2.92884 12.3361 0 8.72319 0C5.11029 0 2.18146 2.92884 2.18146 6.54174C2.18146 8.4635 3.01012 10.1917 4.32963 11.3885C1.73992 14.7918 5.19865e-06 21.1122 0 28.347H17.4446C17.4446 21.1129 15.705 14.793 13.1157 11.3895Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1157 11.3895C14.4358 10.1926 15.2649 8.464 15.2649 6.54174C15.2649 2.92884 12.3361 0 8.72319 0C5.11029 0 2.18146 2.92884 2.18146 6.54174C2.18146 8.4635 3.01012 10.1917 4.32963 11.3885C1.73992 14.7918 5.19865e-06 21.1122 0 28.347H17.4446C17.4446 21.1129 15.705 14.793 13.1157 11.3895Z"
      fill="#E2E2E2"
    />
    <path
      d="M13.1157 11.3895L11.6044 9.7226L10.0752 11.109L11.325 12.7518L13.1157 11.3895ZM4.32963 11.3885L6.12017 12.7511L7.37 11.1086L5.84126 9.72198L4.32963 11.3885ZM0 28.347L-2.25 28.347L-2.25 30.597H0V28.347ZM17.4446 28.347V30.597H19.6946L19.6946 28.347L17.4446 28.347ZM13.0149 6.54174C13.0149 7.80273 12.474 8.93424 11.6044 9.7226L14.627 13.0564C16.3977 11.451 17.5149 9.12527 17.5149 6.54174H13.0149ZM8.72319 2.25C11.0935 2.25 13.0149 4.17148 13.0149 6.54174H17.5149C17.5149 1.6862 13.5787 -2.25 8.72319 -2.25V2.25ZM4.43146 6.54174C4.43146 4.17148 6.35293 2.25 8.72319 2.25V-2.25C3.86765 -2.25 -0.0685434 1.6862 -0.0685434 6.54174H4.43146ZM5.84126 9.72198C4.97213 8.93364 4.43146 7.8024 4.43146 6.54174H-0.0685434C-0.0685434 9.12459 1.04811 11.4498 2.81799 13.0551L5.84126 9.72198ZM2.53908 10.026C-0.469127 13.9793 -2.24999 20.8651 -2.25 28.347L2.25 28.347C2.25001 21.3593 3.94897 15.6044 6.12017 12.7511L2.53908 10.026ZM0 30.597H17.4446V26.097H0V30.597ZM19.6946 28.347C19.6946 20.8658 17.9141 13.9806 14.9064 10.0272L11.325 12.7518C13.496 15.6054 15.1946 21.36 15.1946 28.347L19.6946 28.347Z"
      fill="black"
      mask="url(#path-6-inside-1_3613_4141)"
    />
  </svg>
);
